const decideState = (state) => {
  switch (state) {
    case 'Invoices':
      return {
        title: "No invoices yet",
        description: "Once you start using charged services, you will see your invoices here.",
      };
    case 'Payments':
      return {
        title: "No payments yet",
        description: "Once you start receiving payments, you will see them here.",
        buttonText: "Create Your First Payment Link",
        link: "/payment-link/create",
      };
    case 'Ecommerce Sessions':
      return {
        title: "No ecommerce sessions yet",
        description: "Once you start receiving payments via the SDK, you will see them here.",
        buttonText: "View the SDK Documentation",
        link: "https://developers.felloh.com/sdk/getting-started",
      };
    case 'Payment Links':
      return {
        title: "No payment links yet",
        description: "Once you create a payment link, you will see them here.",
        buttonText: "Create Your First Payment Link",
        link: "/payment-link/create",
      };
    case 'Refunds':
      return {
        title: "No refunds yet",
        description: "Once you start processing refunds, you will see them here.",
      };
    case 'Scheduled Payments':
      return {
        title: "No scheduled payments yet",
        description: "Once you start creating scheduled payments, you will see them here.",
      };
    case 'Bank Deposits':
      return {
        title: "No bank deposits yet",
        description: "Once you connect your bank account, you will see your bank deposits here.",
        buttonText: "Connect Your Bank Account",
        link: "/organisation/bank",
      };
    case 'Bookings':
      return {
        title: "No bookings yet",
        description: "Once you create your first booking, you will see them here.",
        buttonText: "Create Your First Booking",
        link: "/bookings/create",
      };
    case 'Disbursals':
      return {
        title: "No disbursals yet",
        description: "Once you start receiving transactions, your disbursals will appear here.",
      };
    case 'Customers':
      return {
        title: "No customers yet",
        description: "Once you start receiving payments, you will see your customers here.",
      };
    case 'Surcharged Payments':
      return {
        title: "No surcharged payments yet",
        description: "Once you start receiving surcharged payments, you will see them here.",
      };
    case 'Chargebacks':
      return {
        title: "No chargebacks yet",
        description: "Once you start receiving chargebacks, you will see them here.",
      };
    default:
      return {
        title: "No transactions yet",
        description: "Once you start receiving payments, you will see them here.",
        buttonText: "Create Your First Payment Link",
        link: "/payment-link/create",
      };
  }
};

export default decideState;